import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";
import { breakpoints } from "../../constants/breakpoints";

const styles = createUseStyles(theme => ({
  iframe: {
    width: "100%",
    minHeight: "820px",
  },
  iframeLoading: {
    width: "100%",
    minHeight: "820px",
  }
}));

export default styles;
